const initialStateTeacherCourses = {
  loading: false,
  error: null,
  result: [
    {
      id: null,
      coursename: null,
      description: null,
      imgurl: null,
      hasFinalExam: null,
      modules: [
        {
          coursemoduleid: 0,
          name: null,
          description: 0,
          approvallimit: 0
        }
      ],
      students: [
        {
          studentid: null,
          name: null,
          classname: null,
          status: null,
          donePercentage: null,
          nbrOfModules: 0,
          nbrOfDoneModules: 0,
          nbrOfTimes: 0
        }
      ]
    }
  ],
  statusCode: null
};

export function teacherCoursesReducer(
  state = initialStateTeacherCourses,
  action
) {
  switch (action.type) {
    case "FETCH_TEACHER_COURSES_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case "FETCH_TEACHER_COURSES_SUCCESS": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_TEACHER_COURSES_FAILURE": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }
    case "UNLOCK_TEACHER_FINALEXAM_FULFILLED": {
      return {
        ...state,
        loading: false,
        error: null
      };
    }
    case "UNLOCK_TEACHER_FINALEXAM_REJECTED": {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    default:
      return state;
  }
}
